import { Suspense, type ReactElement } from "react";
import { Route } from "react-router-dom";

import type { RouteConfig } from "./types";

const getElement = (r: RouteConfig): ReactElement | undefined => {
  if (r.component)
    return (
      <Suspense fallback={null}>
        <r.component />
      </Suspense>
    );

  if (r.layout) return <r.layout />;
  return r.element;
};

export const renderRoutes = (configs: RouteConfig[]) =>
  configs
    .filter((r) => r.when !== false)
    .map((r) => {
      const element = getElement(r);
      const children = r.children ? renderRoutes(r.children) : undefined;

      return r.index ? (
        <Route index element={element} key={r.path || "index"} />
      ) : (
        <Route path={r.path} element={element} key={r.path}>
          {children}
        </Route>
      );
    });
